module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 7 15",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#facebook",
      toString: function () {
        return this.url;
      }
    }